<div mat-dialog-title>
	<span translate>n4steel.contact-mail</span>
</div>
<form [formGroup]="contactMailForm" (ngSubmit)="sendMessage(contactMailForm)">
	<div mat-dialog-content>
		<copo-submission-feedback></copo-submission-feedback>
		<div class="contact-mail-container">
			<div class="contact-mail-data-row">
				<span class="contact-mail-data-row-label" translate>n4steel.contact-mail-from</span>
				<span class="contact-mail-data-row-value">{{gender}} {{lastname}} {{firstname}} ({{email}})</span>
			</div>
			<div [class.copyto-input-error]="contactMailForm.controls['copyTo'].invalid && contactMailForm.controls['copyTo'].touched"
				class="contact-mail-data-row contact-mail-dark-theme contact-mail-lower-input">
				<mat-form-field>
					<mat-label translate>global.copyto</mat-label>
					<input class="contact-mail-dark-theme-line" type="text" matInput maxlength="255" spellcheck="false" autocomplete="off"
							formControlName="copyTo">
					<mat-error translate>n4steel.contact-mail-invalid-email</mat-error>
				</mat-form-field>
			</div>
			<div class="contact-mail-data-row contact-mail-dark-theme contact-mail-lower-input">
				<mat-form-field class="subject-input" floatLabel="always">
					<mat-label translate>global.subject</mat-label>
					<div class="subject-input-text">
						<span>{{ subject }}&nbsp;</span>
						<input matInput class="contact-mail-dark-theme-line"
							type="text"
							required
							maxlength="255"
							autocomplete="off"
							formControlName="messageSubject">
					</div>
					<mat-error *ngIf="contactMailForm.controls['messageSubject'].touched &&
						contactMailForm.controls['messageSubject'].invalid" translate>global.subject-error-msg</mat-error>
				</mat-form-field>
			</div>
			<div class="contact-mail-data-row" *ngIf="data.offer !== undefined && data.mill !== undefined && (data.mill.length > 0 || data.offer.length > 0)">
				<span class="contact-mail-data-row-label" translate>n4steel.contact-mail-prefill-data</span>
			</div>
			<div class="contact-mail-multi-data-block"  *ngIf="data.offer !== undefined && data.offer.length > 0">
				<span class="contact-mail-multi-data-row-label" translate>n4steel.contact-mail-offer</span>
				<span class="contact-mail-multi-data-row-value bold"> <div class="bold">{{data.offer}}</div></span>
			</div>
			<div class="contact-mail-multi-data-block"  *ngIf="data.mill !== undefined && data.mill.length > 0">
				<span class="contact-mail-multi-data-row-label" translate>need4steel.wizard.header.mill</span>
				<span class="contact-mail-multi-data-row-value "> <div class="bold">{{data.mill}}</div></span>
			</div>
			<div class="loader-height" *ngIf="isLoading"><copo-loading-spinner></copo-loading-spinner></div>
			<mat-form-field>
				<mat-label translate>global.message</mat-label>
				<textarea rows="7" class="textarea-no-resize contact-mail-dark-theme-line" type="textarea"
						formControlName="textMessage" 
						maxlength="2500"
						#comment
						matInput spellcheck="false" autocomplete="off"></textarea>
				<mat-hint align="end">{{comment.value.length || 0}}/2500</mat-hint>
				<mat-error *ngIf="contactMailForm.controls['textMessage'].touched &&
				contactMailForm.controls['textMessage'].invalid" translate>global.message-error</mat-error>
			</mat-form-field>
			<br><br>
			<div class="upload-files">
				<button type="button" mat-button class="contact-mail-add-attachment" (click)="fileInput.click()">
					<mat-icon svgIcon="add"></mat-icon>
					<span class="contact-mail-add-attachment-label" translate>n4steel.contact-add-attachment</span>
				</button>
				<div class="uploadfilecontainer" copoAppDragDropFiles (fileDropped)="uploadFile($event)">
					<span class="uploadfilecontainer-label" translate>n4steel.contact-attachment-help</span>
					<input hidden type="file" id="files" #fileInput (change)="uploadFile(fileInput.files)">
				</div>
			</div>
			<div class="files-list">
				<a class="file-item" *ngFor="let file of files;let i= index"
					[href]="getFileUrl(file) | copoSafeUrl"
					target="_blank"
					rel="noopener"
					(click)="showFile($event, file)">
					<mat-icon class="file-item-icon" svgIcon="table_document"></mat-icon>
					<span class="contact-mail-item-text">{{ file.name }}</span>
					<mat-icon class="file-item-delete-icon" svgIcon="delete"
							(click)="deleteAttachment(i);$event.preventDefault();$event.stopPropagation();"></mat-icon>
				</a>
			</div>
		</div>
	</div>
	<div mat-dialog-actions class="contact-mail-save-cancel-button-block-confirmation contact-mail-save-cancel">
		<div class="contact-mail-save-cancel-button-container">
			<button (click)="onCancelClick()" mat-button type="button" class="contact-mail-customize-button">
				<span translate>dashboard.cancel</span>
			</button>
			<button mat-raised-button color="primary" type="submit" *ngIf="contactMailForm" [disabled]="!contactMailForm.valid || isLoading">
				<span translate>global.send</span>
			</button>
		</div>
	</div>
</form>